<template>
  <div>
    <div class=''>
      <div>
        <div sm='4'>
          <!-- Calendarios -->
          <select
            @keydown.33.capture.prevent.stop
            @keydown.34.capture.prevent.stop
            @keydown.35.capture.prevent.stop
            @keydown.pause='$refs.idesc.focus'
            ref='icalend'
            v-model='calenlabselect'
            class='form-control form-control-sm'
            @change='calendarioChange()'>
            <option disabled value='0' selected='selected'>Seleccione calendario</option>
            <option v-for='calenlab in calenlablist' :key='calenlab.mscalenlabid' :value='calenlab.mscalenlabid'>
              {{ `(${calenlab.mscalenlabanho}) ` }} {{ calenlab.mscalenlabnombre }}
            </option>
          </select>
          <span class="col-underline">{{ $t('lang.mantenimiento.calenlab.calenasoc') }}</span>
          <!--  -->
          <!-- CORRECTO -->
          <v-alert
            class='p-0'
            :show='dismissCountDownCorrect'
            variant='primary'
            @dismissed='dismissCountDownCorrect=0'
            @dismiss-count-down='countDownChangedCorrect'>
            {{ $t('lang.personas.alerta.correcto') }}
          </v-alert>
          <!-- ERROR -->
          <v-alert
            class='p-0'
            :show='dismissCountDownError'
            variant='danger'
            @dismissed='dismissCountDownError=0'
            @dismiss-count-down='countDownChangedError'>
            {{ $t('lang.personas.alerta.error') }}
          </v-alert>
        </div>
        <div sm='8' v-if='calenlabselect != 0'>
          <div class='centrado'>
            <img
              class='btn-generico'
              :src='require("@/assets/images/Btn-arrowLeft.gif")'
              :alt="$t('lang.comun.anterior')"
              @click='restarMes()'
            />
            <div class='calendario-mes'>{{ month + ' ' + year }}</div>
            <img
              class='btn-generico'
              :src='require("@/assets/images/Btn-arrowRight.gif")'
              :alt="$t('lang.comun.anterior')"
              @click='sumarMes()'
            />
          </div>
          <!-- Calendario -->
          <div class='calendario-body mt-2 noselect'>
            <div class="calendario-semana">
                <strong class='calendario-dia-semana' v-for='day in days' :key='day'>{{ day }}</strong>
            </div>
            <div class='calendario-dias'>
              <div class='calendario-dias-fila' v-for='semana in calendario' :key='semana.indiceSemana'>
                <div
                  class='calendario-dias-fila-celda-peq pointer'
                  v-for='dia in semana.diasSemana'
                  :key='dia.diaNumber'
                  :class='{ deshabilitado : dia.diaTipo === 0, findesemana: dia.diaTipo === 2, vacaciones: dia.diaTipo === 3, festivo: dia.diaTipo === 4, hoy : dia.hoy }'
                  @click='modificarCalendario(dia.fecha, dia.diaTipo, dia.msvacacionid)'
                >
                  <div class='calendario-dias-fila-celda-dia'>
                    {{ dia.diaNumber }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- FIN. Calendario -->
          <!-- Modificar Dia -->
          <div class='pt-1' v-if='mostrarModificarDia'>
            <div class='pt-2 pl-3 pr-3'>
              <div sm='2'>
                {{ msdiatrabajodia }}
              </div>
              <div sm='3'>
                <!-- Tipo -->
                <select
                  @keydown.33.capture.prevent.stop
                  @keydown.34.capture.prevent.stop
                  @keydown.35.capture.prevent.stop
                  @keydown.pause='$refs.idesc.focus'
                  ref='itipo'
                  v-model='diatrabajo.msdiatrabajotipo'
                  class='form-control form-control-sm'>
                  <option disabled value='0' selected='selected'>Seleccione tipo</option>
                  <option value=1 >F. Nacional</option>
                  <option value=2 >F. Regional</option>
                  <option value=3 >F. Local</option>
                  <option value=4 >F. Otros</option>
                </select>
              </div>
              <div sm='1' class='pl-2'>
                <label size='sm' for='idesc'>{{ leyenda.descripcion }}</label>
              </div>
              <div sm='6'>
                <!-- Descripcion -->
                <b-form-input
                  @keydown.33.capture.prevent.stop
                  @keydown.34.capture.prevent.stop
                  @keydown.35.capture.prevent.stop
                  ref='idesc'
                  id='idesc'
                  size='sm'
                  type='text'
                  v-model='diatrabajo.msdiatrabajodesc'>
                </b-form-input>
              </div>
            </div>
          </div>
          <div v-else>
            <small>Seleccione un día</small>
          </div>
          <!-- FIN. Modificar Dia -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { CalenlabApiService } from '@/api/CalenlabApiService'
import { DiatrabajoApiService } from '@/api/DiatrabajoApiService'
import { Util } from '@/api/Util'

// Componentes
import BFormInput from 'bootstrap-vue/esm/components/form-input/form-input'
// import BFormInvalidFeedback from 'bootstrap-vue/es/components/form/form-invalid-feedback'

import Const from '@/util/Const'

const calenlabApiService = new CalenlabApiService()
const diatrabajoApiService = new DiatrabajoApiService()
const util = new Util()
const moment = require('moment')

export default {
  data () {
    return {
      today: moment(),
      dateContext: moment(),
      lang: sessionStorage.getItem('lang'),
      vacacion: [],
      calendarioLaboral: [],
      opuid: '',
      days: [
        this.$t('lang.calendario.lun'),
        this.$t('lang.calendario.mar'),
        this.$t('lang.calendario.mie'),
        this.$t('lang.calendario.jue'),
        this.$t('lang.calendario.vie'),
        this.$t('lang.calendario.sab'),
        this.$t('lang.calendario.dom')
      ],
      leyenda: {
        descripcion: this.$t('lang.comun.descripcioncorta')
      },
      mostrarModificarDia: false,
      diatrabajo: {
        msdiatrabajoid: 0,
        msdiatrabajotipo: 0,
        msdiatrabajodesc: ''
      },
      msdiatrabajodia: '',
      msdiatrabajodescmaxchars: 256,
      // Tiempo en segundos que se muestra el mensaje de alerta
      dismissSecs: 2,
      dismissCountDownCorrect: 0,
      dismissCountDownError: 0,
      calenlablist: [],
      calenlabselect: 0
    }
  },
  props: {
    personaParam: Object,
    tabSeleccionado: Number,
    clickGuardarCalenlab: Number,
    clickBorrarCalenlab: Number
  },
  components: {
    BFormInput,
    // BFormInvalidFeedback,

  },
  created () {
    this.init()
  },
  mounted () {
    this.reset()
    this.mountListenerTeclas()
    this.getAllCalenlabByOpUid()
  },
  watch: {
    personaParam: {
      handler (n, o) {
        if (n.mspersonaid !== o.mspersonaid) {
          this.reset(n)
        }
      },
      deep: true
    },
    year: {
      handler (n, o) {
        if (n !== o) {
          this.getAllCalenlabByOpUid()
          // this.findAllDiatrabajo()
          this.mostrarModificarDia = false
        }
      },
      deep: true
    },
    mes: {
      handler (n, o) {
        if (n !== o) {
          this.mostrarModificarDia = false
        }
      },
      deep: true
    }
  },
  methods: {
    init () {
      moment.locale(this.lang)
      this.today = moment()
      this.dateContext = moment()
      // this.getVacacionByPersonaId()
      if (sessionStorage.getItem('opUid')) {
        // Parseamos la persona almacenada en session
        this.opuid = sessionStorage.getItem('opUid')
      }
      this.findAllDiatrabajo()
    },
    calendarioChange () {
      this.findAllDiatrabajo()
    },
    mountListenerTeclas () {
      // Anhadimos el listener para guardar (Tecla FIN=35)
      window.addEventListener('keyup', (e) => {
        if (e.keyCode === 35) {
          if (this.tabSeleccionado === 6) {
            this.createDiatrabajo()
          }
        } else if (e.keyCode === 46) { // Supr
          if (this.tabSeleccionado === 6) {
            this.deleteDiatrabajo()
          }
        }
      })
      this.isMountedDatos = true
    },
    reset () {
      this.today = moment()
      this.dateContext = moment()
    },
    sumarMes: function () {
      this.dateContext = moment(this.dateContext).add(1, 'month')
    },
    restarMes: function () {
      this.dateContext = moment(this.dateContext).subtract(1, 'month')
    },
    findAllDiatrabajo () {
      if (this.calenlabselect > 0) {
        diatrabajoApiService.findAllDiatrabajo( { msdiatrabajocalenlabid: this.calenlabselect } )
          .then(data => {
            util.mostrarEnConsola('PersonasTabMantCalenlab - findAllDiatrabajo', data.length, 'OK')
            this.calendarioLaboral = data
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabMantCalenlab - findAllDiatrabajo', error, 'ERROR')
          })
      }
    },
    checkDia: function (dia, mes, anho) {
      var diaObj = {
        diaNumber: null,
        diaStr: '',
        diaTipo: 0,
        msvacacionid: -1
      }
      if (dia && mes && anho) {
        var fecha = moment(dia + '-' + mes + '-' + anho, 'DD-MMM-YYYY')
        diaObj.fecha = fecha

        if (this.isFestivo(fecha)) { // Comprobamos si es festivo
          diaObj.diaNumber = dia
          diaObj.diaStr = String(dia)
          diaObj.diaTipo = 4
        } else if (moment(fecha).day() % 6 === 0) { // Fin de semana
          diaObj.diaNumber = dia
          diaObj.diaStr = String(dia)
          diaObj.diaTipo = 2
        } else { // Todo lo demas
          diaObj.diaNumber = dia
          diaObj.diaStr = String(dia)
          diaObj.diaTipo = 1
        }

        if (moment(fecha).isSame(new Date(), 'day')) {
          diaObj.hoy = true
        }
      }
      return diaObj
    },
    isFestivo (fecha) {
      if (this.calendarioLaboral.length > 0) {
        for (let i = 0; i < this.calendarioLaboral.length; i++) {
          const calendarioLaboralItem = this.calendarioLaboral[i]
          if (moment(fecha).isSame(calendarioLaboralItem.msdiatrabajofecha)) {
            if (calendarioLaboralItem.msdiatrabajotipo === 1 || calendarioLaboralItem.msdiatrabajotipo === 2 || calendarioLaboralItem.msdiatrabajotipo === 3 || calendarioLaboralItem.msdiatrabajotipo === 4) {
              return true
            }
          }
        }
        return false
      }
    },
    modificarCalendario (fecha, diaTipo, msvacacionid) {
      if (fecha != undefined) {
        let fechaFormat = fecha.format('YYYYMMDD')
        let encontrado = false

        // Buscamos el dia
        if (this.calendarioLaboral && this.calendarioLaboral.length > 0) {
          for (let i = 0; i < this.calendarioLaboral.length; i++) {
            const dia = this.calendarioLaboral[i];
            if (fechaFormat === dia.msdiatrabajofechastr) {
              this.diatrabajo.msdiatrabajotipo = dia.msdiatrabajotipo
              this.diatrabajo.msdiatrabajodesc = dia.msdiatrabajodesc
              this.diatrabajo.msdiatrabajoid = dia.msdiatrabajoid
              encontrado = true
            }
          }
        }

        if (!encontrado) {
          this.diatrabajo.msdiatrabajoid = 0
          this.diatrabajo.msdiatrabajotipo = 0
          this.diatrabajo.msdiatrabajodesc = ''
        }
        this.diatrabajo.msdiatrabajofecha = fecha
        this.diatrabajo.msdiatrabajofechastr = fechaFormat

        this.msdiatrabajodia = fecha.format('DD MMM')

        this.mostrarModificarDia = true
      }
    },
    deleteDiatrabajo () {
      if (this.diatrabajo.msdiatrabajoid !== 0) {
        calenlabApiService.deleteDiatrabajo(this.diatrabajo)
            .then(data => {
              this.showCorrectAlert()
              util.mostrarEnConsola('PersonasTabMantCalenlab - deleteDiatrabajo', data.status, 'OK')
              this.findAllDiatrabajo()
              this.diatrabajo.msdiatrabajodesc = ''
              this.diatrabajo.msdiatrabajotipo = '0'
            })
            .catch(error => {
              this.showErrorAlert()
              util.mostrarEnConsola('PersonasTabMantCalenlab - deleteDiatrabajo', error, 'ERROR')
            })
      }
    },
    createDiatrabajo () {
      if (this.diatrabajo && this.isValidDescDim() && this.diatrabajo.msdiatrabajotipo !== 0 && this.calenlabselect > 0) {
        this.diatrabajo.msdiatrabajocalenlabid = this.calenlabselect
        
        switch (this.diatrabajo.msdiatrabajotipo) {
          case '1':
            this.diatrabajo.msdiatrabajotipostr = Const.CONST_FNACIONAL
            break;
          case '2':
            this.diatrabajo.msdiatrabajotipostr = Const.CONST_FREGIONAL
            break;
          case '3':
            this.diatrabajo.msdiatrabajotipostr = Const.CONST_FLOCAL
            break;
          case '4':
            this.diatrabajo.msdiatrabajotipostr = Const.CONST_FOTROS
            break;
          default:
            this.diatrabajo.msdiatrabajotipostr = Const.CONST_FOTROS
            break;
        }

        calenlabApiService.createDiatrabajo(this.diatrabajo)
            .then(data => {
              this.showCorrectAlert()
              util.mostrarEnConsola('PersonasTabMantCalenlab - createDiatrabajo', data.status, 'OK')
              this.findAllDiatrabajo()
            })
            .catch(error => {
              this.showErrorAlert()
              util.mostrarEnConsola('PersonasTabMantCalenlab - createDiatrabajo', error, 'ERROR')
            })
      }
    },
    isValidDescDim: function () {
      if (this.diatrabajo) {
        if (util.isValidStringField(this.diatrabajo.msdiatrabajodesc, this.msdiatrabajodescmaxchars)) {
          return true
        } else {
          return false
        }
      }
    },
    getAllCalenlabByOpUid () {
      if (this.opuid) {
        calenlabApiService.getAllCalenlabByOp(this.opuid, this.year)
          .then(data => {
            util.mostrarEnConsola('PersonasTabMantCalenlab - getAllCalenlabByOpUid', data.length, 'OK')
            this.calenlablist = data
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabMantCalenlab - getAllCalenlabByOpUid', error, 'ERROR')
          })
      }
    },
    showCorrectAlert () {
      this.dismissCountDownCorrect = this.dismissSecs
    },
    countDownChangedCorrect (dismissCountDownCorrect) {
      this.dismissCountDownCorrect = dismissCountDownCorrect
    },
    showErrorAlert () {
      this.dismissCountDownError = this.dismissSecs
    },
    countDownChangedError (dismissCountDownError) {
      this.dismissCountDownError = dismissCountDownError
    }
  },
  computed: {
    year: function () {
      return this.dateContext.format('Y')
    },
    mes: function () {
      return this.dateContext.format('MM')
    },
    month: function () {
      return this.dateContext.format('MMMM')
    },
    daysInMonth: function () {
      return this.dateContext.daysInMonth()
    },
    currentDate: function () {
      return this.dateContext.get('date')
    },
    firstDayOfMonth: function () {
      var firstDay = moment(this.dateContext).subtract((this.currentDate - 1), 'days')
      return firstDay.weekday()
    },
    initialDate: function () {
      return this.today.get('date')
    },
    initialMonth: function () {
      return this.today.format('MMMM')
    },
    initialYear: function () {
      return this.today.format('Y')
    },
    weekOfMonth: function () { // Semana con respecto al mes
      return this.dateContext.week() - moment(this.dateContext).startOf('month').week() + 1
    },
    numberOfWeeksOfMonth: function () {
      const dateFirst = moment(this.dateContext).date(1)
      const dateLast = moment(this.dateContext).date(this.dateContext.daysInMonth())
      const startWeek = dateFirst.isoWeek()
      const endWeek = dateLast.isoWeek()
      if (endWeek < startWeek) {
        return (Math.abs(dateFirst.isoWeeksInYear() - startWeek) + endWeek) + 1
      } else {
        return endWeek - startWeek + 1
      }
    },
    calendario: function () {
      const calendario = []
      var d = 1
      for (var semana = 0; semana < this.numberOfWeeksOfMonth; semana++) {
        // Creamos los días de la semana
        if (semana === 0) { // Primera semana
          const semanaArray = {
            indiceSemana: semana,
            diasSemana: []
          }
          for (var x = 0; x < this.firstDayOfMonth; x++) {
            semanaArray.diasSemana.push(this.checkDia(null, this.month, this.year))
          }
          for (var l = this.firstDayOfMonth; l < 7; l++) {
            semanaArray.diasSemana.push(this.checkDia(d, this.month, this.year))
            d++
          }
          calendario.push(semanaArray)
        } else if (semana === this.numberOfWeeksOfMonth - 1) { // Ultima semana
          const semanaArray = {
            indiceSemana: semana,
            diasSemana: []
          }
          for (var i = 0; i < 7; i++) {
            if (d <= this.daysInMonth) {
              semanaArray.diasSemana.push(this.checkDia(d, this.month, this.year))
              d++
            } else {
              semanaArray.diasSemana.push(this.checkDia(null, this.month, this.year))
            }
          }
          calendario.push(semanaArray)
        } else { // Resto de semanas
          const semanaArray = {
            indiceSemana: semana,
            diasSemana: []
          }
          for (let j = 0; j < 7; j++) {
            semanaArray.diasSemana.push(this.checkDia(d, this.month, this.year))
            d++
          }
          calendario.push(semanaArray)
        }
      }
      return calendario
    }
  }
}
</script>
